import React, { Component } from 'react';
import { connect } from 'react-redux';
import Moment from 'react-moment';

class Account extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected_plan: null,
      card: {},
      stripe: {},
      stripeData: {
        sources: {
          data: [],
        },
        subscriptions: {
          data: [],
        },
      },
      plans: [
        {
          stripe_plan: 'gc_startup',
          name: 'Startup',
          price: 19,
          description:
            "Ideal for low volume, and those who don't need SMS chat capability.",
          max_conversations: 100,
          max_contacts: 1000,
          max_channels: 2,
          available_channels: ['Live Chat', 'Facebook'],
          additional_features: [],
        },
        {
          stripe_plan: 'gc_business',
          name: 'Business',
          price: 49,
          description:
            'Perfect for those who need high volume of conversations with limited channels.',
          max_conversations: 1000,
          max_contacts: 10000,
          max_channels: 4,
          available_channels: ['Live Chat', 'Facebook', 'SMS'],
          additional_features: ['White label chat widget'],
        },
        {
          stripe_plan: 'gc_growth',
          name: 'Growth',
          price: 79,
          description:
            'Perfect for those who need high volume of conversations with unlimited channels.',
          max_conversations: '∞',
          max_contacts: '∞',
          max_channels: '∞',
          available_channels: ['Live Chat', 'Facebook', 'SMS'],
          additional_features: [
            'White label chat widget',
            'CRM Integration (coming soon)',
          ],
        },
      ],
    };
  }

  fetchBillingInfo() {
    fetch(process.env.REACT_APP_API_URL + '/account/billing', {
      method: 'GET',
      headers: Object.assign(
        { 'Content-Type': 'application/json' },
        this.props.defaultHeaders
      ),
      body: JSON.stringify(),
    })
      .then((res) => {
        res.json().then((body) => {
          console.log(body);
          this.setState({ stripeData: body });
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    this.setState({
      stripe: window.Stripe('pk_test_F9cfn5URQUYhCul5MbeGeAJa'),
    });
    const elements = this.state.stripe.elements();
    this.fetchBillingInfo();

    // Custom styling can be passed to options when creating an Element.
    const style = {
      base: {
        // Add your base input styles here. For example:
        fontSize: '16px',
        lineHeight: '24px',
      },
    };

    // Create an instance of the card Element
    const card = elements.create('card', { style });
    this.setState({ card: card });

    // Add an instance of the card Element into the `card-element` <div>
    card.mount('#card-element');
  }

  async checkWithStripe(e) {
    e.preventDefault();

    const { token, error } = await this.state.stripe.createToken(
      this.state.card
    );

    if (error) {
      // Inform the user if there was an error
      const errorElement = document.getElementById('card-errors');
      errorElement.textContent = error.message;
    } else {
      // Send token.id to the API to store
      fetch(process.env.REACT_APP_API_URL + '/account/billing', {
        method: 'POST',
        headers: Object.assign(
          { 'Content-Type': 'application/json' },
          this.props.defaultHeaders
        ),
        body: JSON.stringify({
          token: token.id,
          plan: this.state.selected_plan,
          quantity: this.props.agents.length,
        }),
      })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  renderStripeSources() {
    if (!this.props.account || !this.props.account.stripe_customer_id) return;

    return (
      <div>
        <p>Currency: {this.state.stripeData.currency}</p>
        <hr />
        {this.state.stripeData.sources.data.map(function (source, i) {
          return (
            <div>
              <p>
                <i className="far fa-cc-visa"></i> - {source.exp_month}/
                {source.exp_year} {source.last4}
              </p>
            </div>
          );
        })}
      </div>
    );
  }

  renderStripeSubscriptions() {
    if (!this.props.account || !this.props.account.stripe_customer_id) return;

    return (
      <div>
        {this.state.stripeData.subscriptions.data.map(function (
          subscription,
          i
        ) {
          return (
            <div>
              <p>
                {subscription.status} - {subscription.quantity} X agents @
                &pound;{subscription.plan.amount / 100} per agent
              </p>
              <p>
                Your trial ends in{' '}
                <Moment
                  fromNow
                  ago
                  date={new Date(subscription.trial_end * 1000)}
                />
              </p>
            </div>
          );
        })}
      </div>
    );
  }

  changePlan(plan) {
    fetch(process.env.REACT_APP_API_URL + '/account/change_plan', {
      method: 'POST',
      headers: Object.assign(
        { 'Content-Type': 'application/json' },
        this.props.defaultHeaders
      ),
      body: JSON.stringify({ plan: plan }),
    })
      .then((res) => {
        res.json().then((body) => {
          console.log(body);
          this.props.account.pricing_plan = plan;
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  renderPricingPlans() {
    return (
      <div className="row no-gutters">
        {this.state.plans.map((plan) => {
          return (
            <div className="col col-4">
              <div className="new-card content-margin content-padding">
                <h3 className="card-title">{plan.name}</h3>
                <p>&pound;{plan.price} per agent/month</p>
                <p className="card-text">{plan.description}</p>
                <hr />
                {this.props.account && this.props.account.stripe_customer_id ? (
                  <div>
                    <p>
                      {this.props.account.pricing_plan === plan.stripe_plan ? (
                        <button className="clickable btn btn-primary btn-block btn-disabled">
                          Your Current Plan
                        </button>
                      ) : (
                        <button
                          className="clickable btn btn-block btn-primary"
                          onClick={() => this.changePlan(plan.stripe_plan)}
                        >
                          Switch to this plan
                        </button>
                      )}
                    </p>
                    <hr />
                  </div>
                ) : (
                  ''
                )}
                <p>{plan.max_conversations} Conversations</p>
                <p>{plan.max_contacts} Contacts</p>
                <p>{plan.max_channels} Channels</p>
                <hr />
                {plan.available_channels.map((channel) => {
                  return <p>{channel}</p>;
                })}
                <hr />
                {plan.additional_features.map((feature) => {
                  return <p>{feature}</p>;
                })}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  renderApproxPrice() {
    if (!this.state.selected_plan) return;

    let price = 0;
    let total = 0;

    switch (this.state.selected_plan) {
      case 'gc_startup':
        price = 19;
        break;
      case 'gc_business':
        price = 49;
        break;
      case 'gc_growth':
        price = 79;
        break;
      default:
        price = null;
    }

    total = this.props.agents.length * price;

    return (
      <span className="approx-price">
        {this.props.agents.length} agents @ &pound;{price} = &pound;{total} per
        month
      </span>
    );
  }

  renderNewSubCard() {
    //if (this.props.account && this.props.account.pricing_plan !== 'freetrial') return;

    return (
      <div className="col col-6">
        <div className="new-card content-margin content-padding">
          <h6>Start your subscription</h6>
          <select
            className="form-control"
            name="selected_plan"
            onChange={this.handleInputChange.bind(this)}
          >
            <option>Please choose a plan...</option>
            {this.state.plans.map((plan) => {
              return (
                <option value={plan.stripe_plan}>
                  {plan.name} - &pound;{plan.price} per agent per month
                </option>
              );
            })}
            ;
          </select>
          <form
            action="/charge"
            method="post"
            id="payment-form"
            onSubmit={this.checkWithStripe.bind(this)}
          >
            <div className="form-row padding-top-bottom">
              <div id="card-element"></div>
              <div id="card-errors"></div>
            </div>

            <hr />
            <button type="submit" className="btn btn-primary">
              Start Subscription
            </button>
            {this.renderApproxPrice()}
          </form>
        </div>
      </div>
    );
  }

  renderOverviewCard() {
    return (
      <div className="col col-6">
        <div className="new-card content-margin content-padding">
          <h6>Overview</h6>
          <div className="form-group row">
            <label for="example-text-input" className="col-4 col-form-label">
              Account Name
            </label>
            <div className="col-8">
              <p className="form-control-static">
                {this.props.account && this.props.account.name}
              </p>
            </div>
          </div>
          <div className="form-group row">
            <label for="example-text-input" className="col-4 col-form-label">
              Current plan
            </label>
            <div className="col-8">
              <p className="form-control-static">
                {this.props.account && this.props.account.pricing_plan}
              </p>
            </div>
          </div>
          <div className="form-group row">
            <label for="example-text-input" className="col-4 col-form-label">
              Agents
            </label>
            <div className="col-8">
              <p className="form-control-static">{this.props.agents.length}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className="row no-gutters">
          {this.renderOverviewCard()}
          {this.renderNewSubCard()}
        </div>
        {this.renderPricingPlans()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    account: state.appState.account,
    defaultHeaders: state.appState.defaultHeaders,
    agents: state.agents,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Account);
